export default "__VITE_ASSET__pCVADO$j__"